// extracted by mini-css-extract-plugin
module.exports = {"default":"NotFound_default__NB_o_","hideMd":"NotFound_hideMd__LATq3","wrapper":"NotFound_wrapper__z0P9d"};